import React, { type CSSProperties } from "react";
import type { ButtonKey } from "../../constants/gamepad";
import { DPadButton } from "./DPadButton";

import DPadUpIcon1x from "../../assets/icons/d_pad_up@1x.webp";
import DPadUpIcon2x from "../../assets/icons/d_pad_up@2x.webp";
import DPadUpIcon3x from "../../assets/icons/d_pad_up@3x.webp";
import DPadDownIcon1x from "../../assets/icons/d_pad_down@1x.webp";
import DPadDownIcon2x from "../../assets/icons/d_pad_down@2x.webp";
import DPadDownIcon3x from "../../assets/icons/d_pad_down@3x.webp";
import DPadLeftIcon1x from "../../assets/icons/d_pad_left@1x.webp";
import DPadLeftIcon2x from "../../assets/icons/d_pad_left@2x.webp";
import DPadLeftIcon3x from "../../assets/icons/d_pad_left@3x.webp";
import DPadRightIcon1x from "../../assets/icons/d_pad_right@1x.webp";
import DPadRightIcon2x from "../../assets/icons/d_pad_right@2x.webp";
import DPadRightIcon3x from "../../assets/icons/d_pad_right@3x.webp";

interface DPadButtonGroupProps {
  onTouchStart: (e: React.TouchEvent, buttonKey: ButtonKey) => void;
  onTouchEnd: (e: React.TouchEvent, buttonKey: ButtonKey) => void;
  onMouseDown: (e: React.MouseEvent, buttonKey: ButtonKey) => void;
  onMouseUp: (e: React.MouseEvent, buttonKey: ButtonKey) => void;
  containerStyle?: CSSProperties;
  buttonStyles?: Partial<Record<ButtonKey, CSSProperties>>;
}

const buttonConfigs = {
  up: { src1x: DPadUpIcon1x, src2x: DPadUpIcon2x, src3x: DPadUpIcon3x },
  down: { src1x: DPadDownIcon1x, src2x: DPadDownIcon2x, src3x: DPadDownIcon3x },
  left: { src1x: DPadLeftIcon1x, src2x: DPadLeftIcon2x, src3x: DPadLeftIcon3x },
  right: {
    src1x: DPadRightIcon1x,
    src2x: DPadRightIcon2x,
    src3x: DPadRightIcon3x,
  },
};

const directions = ["up", "down", "left", "right"] as const;

export const DPadButtonGroup: React.FC<DPadButtonGroupProps> = ({
  onTouchStart,
  onTouchEnd,
  onMouseDown,
  onMouseUp,
  containerStyle = {},
  buttonStyles = {},
}) => {
  return (
    <div style={{ ...baseStyles.dpadContainer, ...containerStyle }}>
      {directions.map((direction) => {
        const config = buttonConfigs[direction];

        return (
          <DPadButton
            key={direction}
            buttonKey={direction as ButtonKey}
            iconConfig={config}
            onTouchStart={(e, buttonKey) => onTouchStart(e, buttonKey!)}
            onTouchEnd={(e, buttonKey) => onTouchEnd(e, buttonKey!)}
            onMouseDown={(e, buttonKey) => onMouseDown(e, buttonKey!)}
            onMouseUp={(e, buttonKey) => onMouseUp(e, buttonKey!)}
            direction={direction}
            style={buttonStyles[direction as ButtonKey]}
          />
        );
      })}
    </div>
  );
};

const baseStyles: { [key: string]: CSSProperties } = {
  dpadContainer: {
    position: "relative",
    width: 132,
    height: 132,
  },
};
